import { PURPOSES } from './constants';

function getCMPData() {
	if (typeof __cmp !== 'function') return null;
	return __cmp('getCMPData');
}

function hasPerformanceCookiesEnabled() {
	const data = getCMPData();
	return data && data.purposeConsents && data.purposeConsents[PURPOSES.PERFORMANCE];
}

function hasTrackingCookiesEnabled() {
	const data = getCMPData();
	return data && data.purposeConsents && data.purposeConsents[PURPOSES.TRACKING];
}

// ConsentManager's `consent` event fires on every page load with stored state,
// not only on user-initiated changes. Persist the last-reported choice so Heap
// only records an event when the consent state actually changes — matching
// OneTrust's OnConsentChanged semantics.
const HEAP_REPORTED_KEY = 'bark_consent_heap_reported';

function reportToHeap() {
	if (!window.heap) return;

	const hasPerformance = hasPerformanceCookiesEnabled();
	const hasTracking = hasTrackingCookiesEnabled();
	let cookieMsg = 'Accepted - All Cookies';

	if (hasPerformance && !hasTracking) {
		cookieMsg = 'Accepted - Performance Cookies Only';
	} else if (!hasPerformance && hasTracking) {
		cookieMsg = 'Accepted - Tracking Cookies Only';
	} else if (!hasPerformance && !hasTracking) {
		cookieMsg = 'Rejected All Cookies';
	}

	let lastReported = null;
	try {
		lastReported = window.localStorage.getItem(HEAP_REPORTED_KEY);
	} catch (e) {
		// localStorage blocked (private mode, etc.) — fall through and fire
	}

	if (lastReported === cookieMsg) return;

	window.heap.track(`User - ${cookieMsg}`);

	try {
		window.localStorage.setItem(HEAP_REPORTED_KEY, cookieMsg);
	} catch (e) {
		// localStorage blocked — next load will re-fire, acceptable fallback
	}
}

function updateTagManager() {
	if (hasPerformanceCookiesEnabled()) {
		gtag('consent', 'update', { analytics_storage: 'granted' });
	}

	if (hasTrackingCookiesEnabled()) {
		gtag('consent', 'update', {
			ad_storage: 'granted',
			ad_personalization: 'granted',
			ad_user_data: 'granted',
		});
	}
}

function updateBingConsent() {
	window.uetq = window.uetq || [];
	if (hasTrackingCookiesEnabled()) {
		window.uetq.push('consent', 'update', {
			ad_storage: 'granted',
		});
	}
}

// Cookie deletion is handled by Consentmanager's built-in auto-deletion
// (Dashboard: Menu > CMPs > Edit > Legal Settings > Delete Cookies)

function init() {
	if (typeof __cmp !== 'function') return;

	// Track banner visibility
	__cmp('addEventListener', 'consentscreen', function () {
		window.heap?.track('User - Seen cookie banner');
	});

	// Track settings/preferences button click
	__cmp('addEventListener', 'consentscreencustom', function () {
		window.heap?.track('User - Clicked cookie settings button');
	});

	// Listen for consent changes
	// Note: OneTrust compatibility mode (enabled in dashboard) handles
	// OnetrustActiveGroups, OneTrustGroupsUpdated, OptanonLoaded, and
	// optanon-category class-based blocking automatically.
	__cmp('addEventListener', 'consent', function () {
		reportToHeap();
		updateTagManager();
		updateBingConsent();
	});
}

init();
